
import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const CloudOptixMappingForm = forwardRef(function CloudOptixMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { accountId, accountName } = props.record;
      return [{id: accountId, name: accountName }]
    }
    return [];
  });

  useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch((err)=>{
        message.error('Problem fetching projects')
      });
      
      return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { accountId } = config;
    return {
      accountId,
      accountName: projects.find(project => project.id === accountId)?.name
    };
  }

  const extraFields = useMemo(() => ([{
      name: 'accountId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Account Name',
      options: projects.map(option => {
        const { label = option.name, value = option.id } = option;
        return { label, value }
      }),
      required: true,
      props: {
        autoFocus: true
      }
    }
  ]), [projects]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default CloudOptixMappingForm;